import React, {useEffect, useState} from "react";
import EmailVerify from "../layouts/Doctor/Components/Dashbord/EmailVerify";
import { Button } from "react-bootstrap";
import { oneKlicks } from "../SDK/oneclick";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getuserdata } from "../services/apiService";

const HospitalSpecialitiesServices = () => {
    const [userdata, setUserdata] = useState({});
    const [specialities, setSpecialities] = useState([]);
    const [services, setServices] = useState([]);
    const [error, setError] = useState(null);
    const [specialityOptions, setSpecialityOptions] = useState([]);
    const [doctorSpecialities, setDoctorSpecialities] = useState([]);
    const [localDoctorId, setLocalDoctorId] = useState("");

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        const localDoctorId = localStorage.getItem("doctorId");
        setLocalDoctorId(localDoctorId);
        console.log("userData", userData);
        if (userData) {
            setUserdata(JSON.parse(userData));
        }
        fetchSpecialities();
        fetchServices();
        fetchDoctorSpecialities();
    }, []);

    const fetchDoctorSpecialities = async () => {
        try {
            const tableSchema = "";
            const tableName = "hospital_specialities";
            const conditions = {
                hospital_id: localDoctorId ? localDoctorId : await getuserdata('id')
            };
            const orderBy = "id DESC";
            const search = "";
            const pagination = "";
            const margedata = "";
            const getDoctorSpecialities = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getDoctorSpecialities", getDoctorSpecialities.data);
            if (getDoctorSpecialities.success && getDoctorSpecialities.data) {
                setDoctorSpecialities(getDoctorSpecialities.data);

                // Group by speciality_id
                const grouped = {};
                getDoctorSpecialities.data.forEach(item => {
                    const serviceId = String(item.id);
                    const specId = String(item.speciality_id);
                    if (!grouped[specId]) {
                        grouped[specId] = {
                            serviceId: serviceId,
                            id: Date.now() + Math.random(), // unique key for React
                            speciality: specId,
                            services: []
                        };
                    }
                    grouped[specId].services.push({
                        id: Date.now() + Math.random(), // unique key for React
                        service: item.service_id,
                        price: item.price,
                        description: item.description,
                        old_service_id: item.id,
                        name: item.name
                    });
                });
                setSpecialities(Object.values(grouped));
            } else {
                throw new Error("Failed to load doctor specialities");
            }
        } catch (error) {
            setError("Failed to load doctor specialities. Please try again.");
        }
    };

    const fetchSpecialities = async () => {
        try {
            const getSpecialities = await oneKlicks.read("", "specialities", {}, "id ASC", "", "", "");
            console.log("getSpecialities", getSpecialities.data);
            if (getSpecialities.success && getSpecialities.data) {
                setSpecialityOptions(getSpecialities.data);
            } else {
                throw new Error("Failed to load specialities");
            }
        } catch (error) {
            setError("Failed to load specialities. Please try again.");
        }
    };
    
    const fetchServices = async () => {
        try {
            const getServices = await oneKlicks.read("", "services", {}, "id ASC", "", "", "");
            console.log("getServices", getServices.data);
            if (getServices.success && getServices.data) {
                setServices(getServices.data);
            } else {
                throw new Error("Failed to load services");
            }
        } catch (error) {
            setError("Failed to load services. Please try again.");
        }
    };

    const getFilteredServices = (specialityId) => {
        if (!specialityId) return [];
        return services.filter(service => service.speciality_id === specialityId);
    };

    const handleAddSpeciality = () => {
        // Prevent adding a speciality that already exists in specialities or doctorSpecialities
        const allSpecialityIds = [
            ...specialities.map(s => String(s.speciality)),
            ...doctorSpecialities.map(ds => String(ds.speciality_id))
        ];
        // Find the first speciality not already added
        const available = specialityOptions.find(opt => !allSpecialityIds.includes(String(opt.id)));
        if (!available) {
            alert('All specialities already added!');
            return;
        }
        setSpecialities([{ id: Date.now(), speciality: available.id, services: [] }, ...specialities]);
    };

    const handleAddService = (specialityId) => {
        setSpecialities(specialities.map(spec => {
            if (spec.id === specialityId) {
                const existingServiceIds = (spec.services || []).map(s => String(s.service));
                const doctorServiceIds = doctorSpecialities
                    .filter(ds => String(ds.speciality_id) === String(spec.speciality))
                    .map(ds => String(ds.service_id));
                const allServiceIds = [...existingServiceIds, ...doctorServiceIds];

                // Find next available service from global list
                const available = services.find(
                    srv =>
                        String(srv.speciality_id) === String(spec.speciality) &&
                        !allServiceIds.includes(String(srv.id))
                );

                const newServiceId = Date.now();

                // 🚨 Case A: services exist → add the next available
                if (available) {
                    return {
                        ...spec,
                        services: [
                            { id: newServiceId, service: available.id, price: "", description: "" },
                            ...(spec.services || [])
                        ]
                    };
                }

                // 🚨 Case B: no services exist at all for this speciality → allow blank row
                if (!services.some(srv => String(srv.speciality_id) === String(spec.speciality))) {
                    return {
                        ...spec,
                        services: [
                            { id: newServiceId, service: null, price: "", description: "" },
                            ...(spec.services || [])
                        ]
                    };
                }

                // 🚨 Case C: all services already added
                alert("All services for this speciality already added!");
                return spec;
            }
            return spec;
        }));
    };

    const handleRemoveSpeciality = (specialityId) => {
        console.log("specialityId delete from UI:", specialityId);
        setSpecialities(specialities.filter(spec => spec.serviceId !== specialityId));
        const tableSchema = "";
        const tableName = "hospital_specialities";
        const condition = { id: specialityId };
        oneKlicks.delete(tableSchema, tableName, condition)
            .then(res => {
                console.log("Deleted from backend:", res);
                toast.success("Speciality deleted successfully");
            })
            .catch(err => {
                console.error("Delete error:", err);
                toast.error("Failed to delete speciality");
            });
    };

    const handleRemoveService = async (specialityId, serviceId) => {
        setSpecialities(specialities.map(spec => {
            if (spec.id === specialityId) {
                // Find the service to be deleted
                const serviceToDelete = (spec.services || []).find(service => service.id === serviceId);
                // If it has an old_service_id, delete from backend
                if (serviceToDelete && serviceToDelete.old_service_id) {
                    const tableSchema = "";
                    const tableName = "hospital_specialities";
                    const condition = { id: serviceToDelete.old_service_id };
                    oneKlicks.delete(tableSchema, tableName, condition)
                        .then(res => {
                            console.log("Deleted from backend:", res);
                            toast.success("Service deleted successfully");
                        })
                        .catch(err => {
                            console.error("Delete error:", err);
                            toast.error("Failed to delete service");
                        });
                }
                // Remove from UI
                return {
                    ...spec,
                    services: (spec.services || []).filter(service => service.id !== serviceId)
                };
            }
            return spec;
        }));
    };

    const handleServiceChange = (specialityId, serviceId, field, value) => {
        setSpecialities(specialities.map(spec => {
            if (spec.id === specialityId) {
                return {
                    ...spec,
                    services: (spec.services || []).map(service =>
                        service.id === serviceId ? { ...service, [field]: value } : service
                    )
                };
            }
            return spec;
        }));
    };

    const handleSpecialityChange = (specialityId, selectedOption) => {
        setSpecialities(specialities.map(spec =>
            spec.id === specialityId
                ? { ...spec, speciality: selectedOption ? selectedOption.value : 0, services: [] }
                : spec
        ));
    };

    const handleServiceDropdownChange = (specialityId, serviceId, selectedOption) => {
        setSpecialities(specialities.map(spec => {
            if (spec.id === specialityId) {
                return {
                    ...spec,
                    services: (spec.services || []).map(service =>
                        service.id === serviceId
                            ? {
                                ...service,
                                service: selectedOption ? selectedOption.value : '',
                                old_service_id: service.old_service_id || null
                            }
                            : service
                    )
                };
            }
            return spec;
        }));
    };

    const getAllServices = () => {
        return services.map(srv => ({
            value: srv.id,
            label: srv.name.replace(/&amp;/g, '&')
        }));
    };

    const getFilteredServicesOptions = (specialityId) => {
        console.log("specialityId", specialityId);
        console.log("services", services);
        const filteredServices = services.filter(
            service => String(service.speciality_id) === String(specialityId)
        );
        console.log("filteredServices", filteredServices);
        return [
            { value: '', label: 'Select Service' },
            ...filteredServices.map(srv => ({
                value: parseInt(srv.id),
                label: srv.name.replace(/&amp;/g, '&')
            }))
        ];
    };

    const handleAddNewService = (specialityId) => {
        // TODO: Replace with modal or form to create a new service for this speciality
        alert('Add new service for speciality ID: ' + specialityId);
    };

    const createService = async (name, specialityId) => {
        // Replace with your actual API call
        const tableSchema = "services";
        const tableName = "services";
        const data = {
            name,
            speciality_id: parseInt(specialityId)
        };
        const conditions = {};

        const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
        if (response.success ) {
            return {
                id: response.insertedData.id,
                name: response.insertedData.name,
                speciality_id: response.insertedData.speciality_id
            };
        } else {
            alert("Failed to create service");
            return null;
        }
    };

    function isServiceChanged(service, doctorSpecialities) {
        if (!service.old_service_id) return true; // Always insert new
        const original = doctorSpecialities.find(
            ds => String(ds.id) === String(service.old_service_id)
        );
        if (!original) return true; // If not found, treat as changed
        return (
            String(original.service_id) !== String(service.service) ||
            String(original.price) !== String(service.price) ||
            String(original.description || '') !== String(service.description || '')
        );
    }

    const handleUpdateServices = async (e) => {
        e.preventDefault();
        // Collect all services with their speciality
        const allServices = specialities.flatMap(spec =>
            (spec.services || []).map(service => ({
                ...service,
                speciality: spec.speciality
            }))
        );

        // Remove duplicates
        const uniqueServices = [];
        const seen = new Set();
        for (const s of allServices) {
            const key = `${s.speciality}_${s.service}`;
            if (!seen.has(key)) {
                seen.add(key);
                uniqueServices.push(s);
            }
        }
        console.log('Unique services:', uniqueServices);

        // Proceed with update using uniqueServices
        for (const service of uniqueServices) {
            const tableSchema = "";
            const tableName = "hospital_specialities";
            const data = {
                speciality_id: service.speciality,
                service_id: service.service,
                name: service.name,
                price: service.price,
                hospital_id: await getuserdata('id'),
                timestamp: service.id,
                description: service.description
            };
            if (service.old_service_id) {
                // Only update if changed
                if (isServiceChanged(service, doctorSpecialities)) {
                    const condition = { id: service.old_service_id };
                    const update = await oneKlicks.update(tableSchema, tableName, data, condition);
                    console.log("update", update);
                    toast.success("Service updated successfully");
                } else {
                    console.log("No change for service", service.old_service_id, "- skipping update");
                }
            } else {
                // Insert new
                const insert = await oneKlicks.create(tableSchema, tableName, data, {});
                console.log("insert", insert);
            }
        }
        toast.success("Services updated successfully");
        fetchDoctorSpecialities();
    };

    const allSpecialityIds = [
        ...specialities.map(s => String(s.speciality)),
        ...doctorSpecialities.map(ds => String(ds.speciality_id))
    ];
    const availableSpeciality = specialityOptions.find(opt => !allSpecialityIds.includes(String(opt.id)));
    const canAddSpeciality = !!availableSpeciality;

    const createSpeciality = async (name) => {
        const tableSchema = "";
        const tableName = "specialities";
        const data = {
            name: name,
            status: "active",
            doctor_id: await getuserdata('id')
        };
        const conditions = {};
        const response = await oneKlicks.create(tableSchema, tableName, data, conditions);
        if (response.success) {
            return {
                id: response.insertedData.id,
                name: response.insertedData.name,
                status: response.insertedData.status,
                doctor_id: response.insertedData.doctor_id
            };
        } else {
            alert("Failed to create speciality");
            return null;
        }
    };

    return (
        <div className="subbody" style={{width: '100%', padding: '2% 4%'}}>
            <ToastContainer position="top-right" autoClose={3000} />
            {userdata.activation_key == null && (
                <EmailVerify/>
            )}
            <section className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <form className="" onSubmit={handleUpdateServices}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-8">
                            <div className="dc-dashboardbox dc-offered-holder">
                                <div className="dc-dashboardboxtitle">
                                    <h2>Manage Hospital Services</h2>
                                </div>
                                <div className="dc-dashboardboxcontent">
                                    <div className="dc-tabscontenttitle dc-addnew">
                                        <h3>Offered Hospital Services</h3>
                                        {canAddSpeciality && (
                                            <Button
                                                className="dc-add_services"
                                                onClick={handleAddSpeciality}
                                                style={{ float: 'right' }}
                                            >
                                                Add New
                                            </Button>
                                        )}
                                    </div>
                                    <div className="dc-specilities-items">
                                        {specialities.map((spec, specIdx) => (
                                            <div className={`repeater-wrap-inner specialities_parents dc-specility-${spec.id}`} id={spec.id} key={spec.id}>
                                                <div className="remove-repeater" onClick={() => handleRemoveSpeciality(spec.serviceId)} key={spec.id}><i className="lnr lnr-trash"></i></div>
                                                <div className="am_field">
                                                    <div className="am_field dropdown-style">
                                                    <span className="dc-select">
                                                            <CreatableSelect
                                                                name={`am_specialities[${spec.id}][speciality_id]`}
                                                                className="sp_services"
                                                                value={specialityOptions.find(option => option.id === parseInt(spec.speciality)) ? {
                                                                    value: parseInt(spec.speciality),
                                                                    label: specialityOptions.find(option => option.id === parseInt(spec.speciality)).name.replace(/&amp;/g, '&')
                                                                } : { value: '', label: 'Select Speciality' }}
                                                                onChange={selectedOption => handleSpecialityChange(spec.id, selectedOption)}
                                                                options={[
                                                                    { value: 0, label: 'Select Speciality' },
                                                                    ...specialityOptions.map(s => ({
                                                                        value: parseInt(s.id),
                                                                        label: s.name.replace(/&amp;/g, '&')
                                                                    }))
                                                                ]}
                                                                isSearchable={true}
                                                                placeholder="Search speciality..."
                                                                noOptionsMessage={() => "No specialities found"}
                                                                onCreateOption={async (inputValue) => {
                                                                    const newSpeciality = await createSpeciality(inputValue);
                                                                    if (newSpeciality) {
                                                                        setSpecialityOptions(prev => [...prev, newSpeciality]);
                                                                        handleSpecialityChange(spec.id, { value: newSpeciality.id, label: newSpeciality.name });
                                                                    }
                                                                }}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                                <ul className="dc-experienceaccordion accordion services-wrap dc-addnew">
                                                    <li className="dc-system-btn-holder">
                                                        <div className="system-buttons">
                                                            <a href="#" onClick={e => { e.preventDefault(); handleAddService(spec.id); }} className="add-repeater-servicess dc-btn">Add Services</a>
                                                        </div>
                                                    </li>
                                                    {(spec.services || []).map((service, srvIdx) => (
                                                        <li className="repeater-wrap-inner services-item" id={service.id} key={service.id}>
                                                            <div className="dc-accordioninnertitle dc-subpaneltitle dc-subpaneltitlevtwo">
                                                                <span>Service title</span>
                                                                <div className="dc-rightarea">
                                                                    <em>Price</em>
                                                                    <div className="dc-btnaction">
                                                                        <a href="#" className="dc-addinfo dc-skillsaddinfo"><i className="lnr lnr-pencil"></i></a>
                                                                        <a href="#" className="dc-deleteinfo" onClick={e => { e.preventDefault(); handleRemoveService(spec.id, service.id); }}><i className="lnr lnr-trash"></i></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="dc-collapseexp show">
                                                                <div className="dc-formtheme dc-userform">
                                                                    <fieldset>
                                                                        <div className="form-group form-group-half">
                                                                            <div className="am_field dropdown-style related-services">
                                                                                <span className="dc-select">
                                                                                    <CreatableSelect
                                                                                        name={`am_specialities[${spec.id}][services][${service.id}][service]`}
                                                                                        className="sp_services"
                                                                                        value={services.find(srv => srv.id === parseInt(service.service)) ? {
                                                                                            value: parseInt(service.service),
                                                                                            label: services.find(srv => srv.id === parseInt(service.service)).name.replace(/&amp;/g, '&')
                                                                                        } : { value: '', label: 'Select Service' }}
                                                                                        onChange={selectedOption => handleServiceDropdownChange(spec.id, service.id, selectedOption)}
                                                                                        options={getFilteredServicesOptions(spec.speciality)}
                                                                                        isSearchable={true}
                                                                                        placeholder="Search service..."
                                                                                        noOptionsMessage={() => "No services found for this speciality"}
                                                                                        onCreateOption={async (inputValue) => {
                                                                                            const newService = await createService(inputValue, spec.speciality);
                                                                                            if (newService) {
                                                                                                setServices(prev => [...prev, newService]);
                                                                                                handleServiceDropdownChange(spec.id, service.id, { value: newService.id, label: newService.name });
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-group form-group-half">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name={`am_specialities[${spec.id}][services][${service.id}][price]`}
                                                                                placeholder="Price"
                                                                                value={service.price}
                                                                                onChange={e => handleServiceChange(spec.id, service.id, 'price', e.target.value)}
                                                                            />
                                                                        </div>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                name={`am_specialities[${spec.id}][services][${service.id}][description]`}
                                                                                className="form-control"
                                                                                placeholder="Description"
                                                                                value={service.description}
                                                                                onChange={e => handleServiceChange(spec.id, service.id, 'description', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="dc-updatall">
                                <i className="ti-announcement" />
                                <span>Post services, by just clicking on "Update Services" button.</span>
                                <button type="submit" className="dc-btn dc-update-servicess">
                                    Update Services
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default HospitalSpecialitiesServices;
